import React, { useState } from 'react';
import JsonNode from './JsonNode';
import { isObject } from '../../utils/typeChecks';
// 1. 방금 만든 Context를 import 합니다.
import JsonViewerContext from './JsonViewerContext';

const getInitialCollapsedState = (data) => {
    const collapsed = {};
    const walk = (obj, path = 'root') => {
        if (isObject(obj)) {
            collapsed[path] = path !== 'root';
            const entries = Array.isArray(obj)
                ? obj.map((v, i) => [i, v])
                : Object.entries(obj);
            for (const [k, v] of entries) {
                walk(v, `${path}.${k}`);
            }
        }
    };
    walk(data);
    return collapsed;
};

const JsonViewer = ({ data }) => {
    const [collapsed, setCollapsed] = useState(() => getInitialCollapsedState(data));

    const toggle = (path) => {
        setCollapsed((prev) => ({ ...prev, [path]: !prev[path] }));
    };

    // 2. Context를 통해 공유할 값들을 하나의 객체로 묶습니다.
    const contextValue = {
        collapsed,
        toggle,
    };

    return (
        // 3. Provider로 전체를 감싸고, contextValue를 전달합니다.
        <JsonViewerContext.Provider value={contextValue}>
            <div style={{ fontFamily: 'monospace', fontSize: 13 }}>
                <JsonNode
                    keyName={null}
                    value={data}
                    depth={0}
                    path="root"
                    // 4. 더 이상 collapsed와 toggle을 prop으로 넘겨주지 않아도 됩니다.
                />
            </div>
        </JsonViewerContext.Provider>
    );
};

export default JsonViewer;